import { IArguments } from '@seb/web-design-system/arguments';
import { richParagraphSkeleton } from '../../models/skeleton/rich-paragraph.skeleton';

export const argumentsSkeleton: IArguments = {
  secondaryMedia: {},
  media: {},
  content: richParagraphSkeleton
};
